export default __webpack_public_path__ + "static/media/cartaoBoleto.f8724854.svg";